import { render } from "./SlDialogError.vue?vue&type=template&id=aa7390a8"
import script from "./SlDialogError.vue?vue&type=script&lang=js"
export * from "./SlDialogError.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__